import React from "react";
import PropTypes from 'prop-types';
import {
    financialProductConfigurationPropTypesShape,
    getFinancialTypeProductEIM,
} from "../../../helpers/financialProductConfigurationHelpers";
// import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {getAppData} from "../../../store/slices/appSlice";
import CONST from "../../../config/CONST";
import CustomerSelection from "../../CustomerSelection/CustomerSelection";
import {getSelectedCustomer, getUserConfigurations} from "../../../store/slices/userConfigurationsSlice";

const CustomersSelection = (props) => {

    const {
        financialProductConfiguration,
        onChange
    } = props;

    const appData = useSelector(getAppData);
    const selectedCustomer = useSelector(getSelectedCustomer) || appData.touchpointConfig.defaults.customer;
    let customersAvailable = appData.touchpointConfig.defaults.availableCustomer;
    const allUserConfigurations = useSelector(getUserConfigurations) || [];
    const userConfiguration = allUserConfigurations.find(c => c.EIM === appData.input.EIM && c.selectedProduct && c.vehicleType === appData.input.vehicleType && c.customer === selectedCustomer);

    if(!appData || !financialProductConfiguration) {
        return null;
    }

    const _financialProducts = getFinancialTypeProductEIM(appData.modelsRatesMapping.find(c => c.EIM === appData.input.EIM), appData.input.vehicleType, customersAvailable[selectedCustomer], selectedCustomer).financialProducts;
    const _availableCustomers = Object.keys(appData.touchpointConfig.defaults.availableCustomer).map( key => {
        const _productIncluded = _financialProducts && _financialProducts.filter(product => appData.touchpointConfig.defaults.availableCustomer[key].includes(product.productTypeCode));
        if(_productIncluded && _productIncluded.length) {
            return {
                typeOfCustomer: key,
                default: key === appData.touchpointConfig.defaults.customer
            };
        }
        else return null;

    }).filter(el => el);

    return (
        <div className={`${CONST.CSS_NAMESPACE}CustomersSelection`}>
            { _availableCustomers.map( customer => {
                return (
                    <CustomerSelection
                        customer={customer}
                        value={customer.typeOfCustomer}
                        key={customer.typeOfCustomer}
                        onChange={onChange}
                        checked={!!userConfiguration?.customer || customer.default}
                    />
                )
            })}
        </div>

    )
}

CustomersSelection.propTypes = {
    financialProductConfiguration: PropTypes.shape(financialProductConfigurationPropTypesShape),
    onChange: PropTypes.func,
}

export default CustomersSelection;